import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import WhiteBlockTitle from './../block/WhiteBlockTitle'
import Showroom from './../block/Showroom'
import Reviews from './../block/Reviews'
import WorkClean from './../block/WorkClean'
import Raschet from './../block/Raschet'
import KontaktiBlock from './../block/Kontakti'
import GreenButton from './../block/GreenButton'
import FeedbackForm from './../block/FeedbackForm'

import { Container, Image } from 'react-bootstrap'

import styles from './../style/KontaktiPage.module.scss'

const TgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Telegram"
    viewBox="0 0 512 512"
    style={{ width: '22px', height: 'auto' }}
  >
    <rect width={512} height={512} fill="#37aee2" rx="15%" />
    <path fill="#c8daea" d="M199 404c-11 0-10-4-13-14l-32-105 245-144" />
    <path fill="#a9c9dd" d="M199 404c7 0 11-4 16-8l45-43-56-34" />
    <path
      fill="#f6fbfe"
      d="m204 319 135 99c14 9 26 4 30-14l55-258c5-22-9-32-24-25L79 245c-21 8-21 21-4 26l83 26 190-121c9-5 17-3 11 4"
    />
  </svg>
)

class Kontakti extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      show_feedback: false
    };
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  // Функция для очистки номера телефона от нецифровых символов
  cleanPhoneNumber = (phone) => {
    return phone.replace(/\D/g, '');
  }

  render() {

    const { data, assets_path } = this.props,
    { show_feedback } = this.state

    const sp_phone = `8 (929) 053-29-93`
    const cleanedPhone = this.cleanPhoneNumber(data?.phone || '');
    const cleanedSpPhone = this.cleanPhoneNumber(sp_phone);

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <Container>
          <WhiteBlockTitle
            title={`Наши контакты`}
            text={``}
          />
          <div className={styles.section}>
            <div className={styles.card}>
              <div className={styles.card_top}>
                <div className={styles.card_title}>Офис</div>
                <div>[01]</div>
              </div>
              <div className={styles.card_line}>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/phone.svg`} width={13} height={13} alt={`tel`} />
                  <div>
                    <a href={`tel:${cleanedPhone}`} style={{ textDecoration: 'none' }} className={styles.card_line_el_title}>
                      {data?.phone}
                    </a>
                    <div>Номер телефона</div>
                  </div>
                </div>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/wa.svg`} width={22} height={22} alt={`wa`} />
                  <div>
                    <a href={`https://wa.me/+79290532993`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }} className={styles.card_line_el_title}>
                      {sp_phone}
                    </a>
                    <div>Мессенджер WhatsApp</div>
                  </div>
                </div>
              </div>
              <div className={styles.card_line}>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/glob.svg`} width={13} height={13} alt={`tel`} />
                  <div>
                    <div className={styles.card_line_el_title}>{data?.adres} (вход с правого торца здания)</div>
                    <a style={{ color: `#0009`, textDecoration: `none` }} target="_blank" rel="noopener noreferrer" href="https://yandex.ru/maps/47/nizhny-novgorod/?ll=44.001118%2C56.311536&mode=routes&rtext=~56.311536%2C44.001118&rtt=auto&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fdata%3DIgoNJQEwQhUDP2FC&z=17">Проложить маршрут</a>
                  </div>
                </div>
              </div>
              <div className={styles.card_line}>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/clock.svg`} width={17} height={17} alt={`c`} />
                  <div>
                    <div className={styles.card_line_el_title}>ПН-ПТ с 9:30 до 19:00</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.card_top}>
                <div className={styles.card_title}>Производство</div>
                <div>[02]</div>
              </div>
              <div className={styles.card_line}>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/phone.svg`} width={13} height={13} alt={`tel`} />
                  <div>
                    <a href={`tel:${cleanedPhone}`} style={{ textDecoration: 'none' }} className={styles.card_line_el_title}>
                      {data?.phone}
                    </a>
                    <div>Номер телефона</div>
                  </div>
                </div>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/clock.svg`} width={17} height={17} alt={`c`} />
                  <div>
                    <div className={styles.card_line_el_title}>ПН-ПТ с 7:30 до 16:30</div>
                    <div>Режим работы</div>
                  </div>
                </div>
              </div>
              <div className={styles.card_line}>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/glob.svg`} width={13} height={13} alt={`g`} />
                  <div>
                    <div className={styles.card_line_el_title}>Кстово, ул. Лесная, д. 2</div>
                    <a style={{ color: `#0009`, textDecoration: `none` }} href="https://yandex.ru/maps/20044/kstovo/?ll=44.166605%2C56.168802&mode=routes&rtext=~56.168802%2C44.166605&rtt=auto&ruri=~ymapsbm1%3A%2F%2Fgeo%3Fdata%3DCgoxNjg3MDk4MzE3EnPQoNC-0YHRgdC40Y8sINCz0L7RgNC-0LTRgdC60L7QuSDQvtC60YDRg9CzINCd0LjQttC90LjQuSDQndC-0LLQs9C-0YDQvtC0LCDQmtGB0YLQvtCy0L4sINCb0LXRhdC90LDRjyDRg9C70LjRhtCwLCAyIgoNnKowQhXarGBC&z=17.63" target="_blank" rel="noopener noreferrer">Проложить маршрут</a>
                  </div>
                </div>
                <div className={styles.card_line_el}>
                  <GreenButton
                    text={`Позвонить нам`}
                    width={162}
                    action={() => { this.showFeedback() }}
                  />
                  <FeedbackForm
                    title={`Позвонить нам`}
                    text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                    btn={`Отправить`}
                    data={[]}
                    show={show_feedback}
                    handleClose={() => this.closeFeedback()}
                  />
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.card_top}>
                <div className={styles.card_title}>Сайт и E-mail</div>
                <div>[03]</div>
              </div>
              <div className={styles.card_line}>
                <div className={styles.card_line_el}>
                  <Image src={`/${assets_path}/images/glob.svg`} width={13} height={13} alt={`g`} />
                  <div>
                    <div className={styles.card_line_el_title}>goodwin-nnov.ru</div>
                    <a style={{ color: `#0009`, textDecoration: `none` }} href={`mailto:${data?.sitemail}`}>{data?.sitemail}</a>
                  </div>
                </div>
              </div>
              <div className={styles.card_line}>
                <div className={styles.card_line_el}>
                  <TgIcon />
                  <div>
                    <a style={{ textDecoration: 'none' }} href="https://t.me/+79290532993" target="_blank" rel="noopener noreferrer" className={styles.card_line_el_title}>+79290532993</a>
                    <div>Мессенджер Telegram</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
        <Showroom
          data={data?.showroom || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          assets_path={assets_path}
        />
        <Reviews
          data={data?.reviews || {}}
          logo={data?.logo}
          sitename={data?.sitename}
          assets_path={assets_path}
          margin={`y2`}
        />
        <WorkClean
          data={data?.workclean || {}}
          assets_path={assets_path}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <KontaktiBlock
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

Kontakti.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Kontakti.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Kontakti